import { render } from "./ollaHead.vue?vue&type=template&id=28306d24&scoped=true"
import script from "./ollaHead.vue?vue&type=script&lang=js"
export * from "./ollaHead.vue?vue&type=script&lang=js"

import "./ollaHead.vue?vue&type=style&index=0&id=28306d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28306d24"]])

export default __exports__